<template>
  <div class="py-4 container-fluid">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-lg-12 position-relative z-index-2">
        <div class="row">
          <div class="col-sm-7">
            <h1 class="mainTitle">Dashboard</h1>
            <span class="mainDescription">Hello, Admin</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Stats Cards -->
    <div class="row">
      <div class="col-xl-4 col-sm-6 mb-4" v-for="card in stats" :key="card.title">
        <div class="card shadow border-0" :style="{ backgroundColor: '#FFC55A', color: '#000' }">
          <div class="card-body text-center py-4">
            <div class="mb-2">
              <i class="material-icons-round" style="font-size: 2rem; color: black">{{ card.icon }}</i>
            </div>
            <h6 class="text-black text-sm mb-1">{{ card.title }}</h6>
            <h4 class="mb-0 text-black">{{ card.value }}</h4>
          </div>
        </div>
      </div>
    </div>

    <!-- Quick Links -->
    <div class="row mt-4">
      <div class="col-md-12">
        <h5 class="mb-3">Quick Actions</h5>
        <div class="d-flex gap-3 flex-wrap">
          <router-link to="/products/create" class="btn text-black" style="background-color: #FFC55A">
            <i class="material-icons-round me-1">add</i> New Product
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/Axios";
import showSwal from "@/mixins/showSwal";

export default {
  name: "dashboard-default",
  mixins: [showSwal],
  data() {
    return {
      stats: [
        { title: "Users", value: 0, icon: "people", key: "users" },
        { title: "Orders", value: 0, icon: "receipt_long", key: "orders" },
        { title: "Products", value: 0, icon: "inventory_2", key: "products" },
      ],
    };
  },

  async created() {
    this.loadData();
  },

  methods: {
    async loadData() {
      try {
        // Fetch statistics from the dedicated endpoint
        const statsRes = await axios.get("/dashboard/stats");
        const dashboardStats = statsRes.data.data || {};

        // Fetch order statistics (optional, for future use in charts)
        // const orderReportRes = await axios.get("/dashboard/order-report");

        this.stats = [
          { 
            title: "Users", 
            value: dashboardStats.users || 0, 
            icon: "people", 
            key: "users" 
          },
          { 
            title: "Orders", 
            value: dashboardStats.orders || 0, 
            icon: "receipt_long", 
            key: "orders" 
          },
          { 
            title: "Products", 
            value: dashboardStats.products || 0, 
            icon: "inventory_2", 
            key: "products" 
          },
        ];

      } catch (error) {
        console.error("Failed to load dashboard data:", error);
        this.showSwal({
          type: "error",
          message: "Failed to load dashboard statistics. The numbers below may be out of date.",
        });
      }
    },
  },
};
</script>

<style scoped>
/* Removed the full page background override */
</style>
